import createElementChangeListener from "../elementChangeListener";
import curry from "../lib/core/functional/curry";
import { appendToCurrentDebug } from "./utils";

function addToSearchParams(anchorSearchParams, abtest) {
    const [abTestName, abTestValue] = abtest;
    anchorSearchParams.set(abTestName, abTestValue);
    return anchorSearchParams;
}

const addBtestQueryParam = curry(function addBtestQueryParam(abtestList, anchorElement) {
    let anchorUrl;
    const ogHref = anchorElement.dataset.ogHref || anchorElement.href;
    try {
        anchorUrl = new URL(ogHref);
    } catch {
        return;
    }

    if (
        anchorUrl.host !== document.location.host ||
        anchorUrl.pathname.indexOf("/r/layouts-editor/") >= 0
    ) {
        return;
    }

    const anchorSearchParams = new URLSearchParams(anchorUrl.search);
    abtestList.reduce(addToSearchParams, anchorSearchParams);
    anchorSearchParams.set("debugld", appendToCurrentDebug("stickybtest"));
    anchorUrl.search = `?${anchorSearchParams.toString()}`;
    anchorElement.href = anchorUrl.href;
    anchorElement.dataset.ogHref = ogHref;
});

function populateBtestLinks(abtestList) {
    createElementChangeListener("a[href]", addBtestQueryParam(abtestList));
}

function findBTestInDocument([queryName, queryValue]) {
    return !!document.querySelector(
        `script[data-abtest-name="${queryName}"][data-abtest-value="${queryValue}"]`
    );
}

function getCurrentBtest(allQueryParams) {
    return [...allQueryParams].find(findBTestInDocument);
}

export function makeSticky(queryEntries) {
    populateBtestLinks(queryEntries);
}

export default function enableStickyBtestFromParams() {
    const allQueryParams = Array.from(new URLSearchParams(document.location.search));

    let abtestList;
    const currentBtest = getCurrentBtest(allQueryParams);
    if (currentBtest) {
        abtestList = [currentBtest];
    } else {
        abtestList = allQueryParams;
    }
    makeSticky(abtestList);
}
